<template>
    <div class="home">
      <div class="row pt-5">
        <div class="col">
          <h1>Programma Condizioni</h1>
          <div style="display:flex;flex-direction:row" class="container">
            <button v-for="system in systems" :key="system.id" @click="loadConditions(system.id)">{{ system.system_name
            }}</button>
          </div>
          <div style="display:flex;flex-direction:row;flex-wrap:wrap" class="container">
            <div class="card" style="width: auto;" v-for="subProduct in conditions" :key="subProduct.sub_product_id">
              <div class="card-body">
                <h5 class="card-title">Prodotto <span>
                    <select v-model="subProduct.sub_product_id">
                      <option v-for="product in products" :key="product.id" :value="product.id">{{
                        product.product_name }}</option>
                    </select>
                  </span></h5>
                <p class="card-text">Lista condizioni</p>
              </div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item" v-for="(condition, i) in subProduct.conditions" :key="condition.condition_id"
                  style="display:flex">
                  <select v-if="i > 0" v-model="condition.condition_logic">
                    <option value="and">E</option>
                    <option value="or">O</option>
                  </select>
  
                  <select v-model="condition.condition_type">
                    <option value="always">Sempre presente</option>
                    <option value="mq">MQ</option>
                    <option value="base">Base</option>
                  </select>
  
                  <div v-if="condition.condition_type == 'always'">
                  </div>
  
                  <div v-if="condition.condition_type == 'mq'" style="display:flex">
                    <select v-model="condition.mq_logic">
                      <option value="bigger_than"> più di </option>
                      <option value="less_than"> meno di </option>
                    </select>
                    <input v-model="condition.mq_value" type="number">
                  </div>
  
                  <div v-if="condition.condition_type == 'base'" style="display:flex">
                    <select v-model="condition.base_id">
                      <option v-for="base in bases" :key="base.id" :value="base.id">{{ base.base_name }}</option>
                    </select>
                  </div>
                  <button v-if="condition.condition_id == -1 || i == subProduct.conditions.length - 1"
                    @click="removeCondition(condition, subProduct.sub_product_id, i)">X</button>
                </li>
              </ul>
              <div class="card-body">
                <button @click="addCondition(subProduct.sub_product_id, subProduct.system_id)"
                  class="btn btn-warning">Aggiungi
                  condizione</button>
                <button class="btn btn-success" @click="testConditions(subProduct)">Test</button>
                <button class="btn btn-success" @click="postConditions(subProduct)">Salva</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div>
            <h1>Calcolatore</h1>
            <div>
              Sistema INPUT <select v-model="systemInput">
                <option v-for="system in systems" :key="system.id" :value="system.id">{{ system.system_name
                }}</option>
              </select>
              MQ INPUT <input v-model="MQInput" type="number">
              Base INPUT <select v-model="baseInput">
                <option v-for="base in bases" :key="base.id" :value="base.id">{{ base.base_name }}</option>
              </select>
              <button @click="loadOffer()">Crea</button>
              <div class="container" style="display:flex">
                <div v-for="product in finalResult" :key="product.id" class="card">
                  <h3>{{ product.product_name }} - {{ product.subTotal }}</h3>
                  <div>
                    <p>Variations:</p>
                    <table>
                      <tbody>
                        <tr>
                          <td>Attivo:</td>
                          <td>Packaging:</td>
                          <td>Quantità</td>
                        </tr>
                        <tr v-for="variation in product.variations" :key="variation.id">
                          <td><input type="checkbox" v-model="variation.active"></td>
                          <td>{{ variation.packaging_label }}</td>
                          <td>{{ variation.quantità }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
  
              <div>TOTALE ORDINE: {{ finalResult.orderTotal }}</div>
            </div>
          </div>
        </div>
      </div>
  
  
  
  
  
    </div>
    <div style="position:fixed;right:5px;bottom:5px;display:flex;flex-direction: column;">
      <button @click="testOrder">Archivia</button>
      <button @click="testOrder">PDF</button>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import systemMethods from '../api/resources/systemMethods'
  import productMethods from '../api/resources/productMethods'
  import { ref, onMounted, computed, watchers, watch } from 'vue'
  
  export default {
    name: 'devView',
    setup() {
      const systems = ref([]);
      const conditions = ref([]);
      const products = ref([]);
      const bases = ref([]);
  
  
      const systemInput = ref(1);
      const MQInput = ref(10);
      const baseInput = ref(1);
  
      const productsFromBackend = ref([]);
  
  
      onMounted(async () => {
        let data = await systemMethods.getSystems();
        let dataP = await productMethods.getProducts();
        let dataB = await productMethods.getBases();
        systems.value = data.data;
        products.value = dataP.data;
        bases.value = dataB.data;
      })
  
      async function loadConditions(systemId) {
        //let subProducts = [];
        conditions.value = [];
        let data = await systemMethods.getConditions(systemId);
  
        data.data.forEach((condition) => {
          let toAdd = true;
          let obj = {
            sub_product_id: condition.sub_product_id,
            sub_product_name: condition.sub_product_name,
            system_id: condition.system_id,
            conditions: []
          };
          conditions.value.forEach((e) => {
            if (e.sub_product_id == condition.sub_product_id) {
              toAdd = false;
            }
          })
          if (toAdd) {
            conditions.value.push(obj);
          }
        })
  
        data.data.forEach((condition) => {
          conditions.value.forEach((e) => {
            if (e.sub_product_id == condition.sub_product_id) {
              e.conditions.push(condition);
            }
          })
        })
        console.log(conditions.value)
      }
  
      function addCondition(prodId, systemId) {
        let obj = {
          condition_id: -1,
          sub_product_id: prodId,
          system_id: systemId
        }
        conditions.value.forEach((e) => {
          if (e.sub_product_id == prodId) {
            e.conditions.push(obj);
          }
        })
      }
  
      async function removeCondition(condition, prodId, condIndex) {
        if (condition.condition_id != -1) {
          console.log("è una condizione nel db");
          let res = await systemMethods.removeConditions([condition]);
          console.log(res)
        }
        else {
          console.log("è una condizione NON nel db");
        }
        conditions.value.forEach((e) => {
          if (e.sub_product_id == prodId) {
            e.conditions.splice(condIndex, 1);
          }
        })
      }
  
      async function loadOffer() {
        let obj = {
          mqInput: MQInput.value,
          systemId: systemInput.value,
          baseId: baseInput.value
        }
        let res = await systemMethods.calculate(obj);
        productsFromBackend.value = res.data;
        /*       productsFromBackend.value.forEach((product)=>{
                product.variations.forEach((variation)=>{variation.active = true})
              }) */
      }
  
  
      function calculate(resaF, variations) {
        //calcola le confezioni consigliate a partire dalla resa del prodotto e 
        let total = MQInput.value;
        let results = [];
        let options = variations;
        options.sort(function (a, b) {
          return b.packaging_value - a.packaging_value;
        });
        options.forEach((element, i) => {
          let resa = (1 / resaF) * element.packaging_value;
          let amountConf = Math.floor(total / resa);
          let resConf = total % resa;
          if (resConf > (resa * 1) / 2) {
            amountConf++;
            resConf = 0;
          }
          total = resConf;
          if (i === options.length - 1 && total > 0) {
            amountConf++;
            resConf = 0;
          }
          results.push({ variationId: element.id, confezione: element.packaging_label, quantità: amountConf, price:element.price });
        });
        return results;
      };
  
      const finalResult = computed(() => {
        let temp = productsFromBackend.value;
        var orderTotal = 0;
        temp.forEach((product) => {
          var subTotal = 0;
          let data = calculate(product.yield, product.variations.filter((e) => e.active));
          console.log(data)
          product.variations.forEach((variation) => {
            if (!variation.active) {
              variation.quantità = 0
            }
            data.forEach((option) => {
              if (option.variationId == variation.id) {
                variation.quantità = option.quantità;
                console.log(option.quantità+" moltiplicato "+option.price)
                subTotal += option.quantità*option.price
                orderTotal += option.quantità*option.price
              }
            })
          })
          product.subTotal = subTotal.toFixed(2);
        });
        temp.orderTotal = orderTotal.toFixed(2);
        return temp;
      })
  
  
      function testConditions(data) {
        console.log(data);
      }
  
      async function postConditions(data) {
        let res = await systemMethods.postConditions(data);
        console.log(res);
      }
  
      watch([MQInput, baseInput, systemInput], () => {
        loadOffer();
      });


      function testOrder(){
        let order = [];
        finalResult.value.forEach((product)=>{
          product.variations.forEach((variation)=>{
            if(variation.active && variation.quantità>0){
              order.push(variation);
            }
          })
        })
        console.log(order)
      }
  
  
      return {
        systems, conditions, loadConditions, addCondition, removeCondition, products, bases,
        MQInput, systemInput, baseInput, loadOffer, finalResult,
        testConditions, postConditions,
        testOrder
  
      }
    }
  }
  </script>
  